export default __webpack_public_path__ + "59d2771f5721046b0cb0d0cfa459f532.png";